import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "preserve_scroll:y";

export default class extends Controller {
  connect() {
    this.restore();
  }

  save() {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(window.scrollY || 0));
    } catch (_e) {
      // ignore
    }
  }

  restore() {
    let y;
    try {
      y = sessionStorage.getItem(STORAGE_KEY);
    } catch (_e) {
      y = null;
    }
    if (y == null) return;

    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_e) {
      // ignore
    }

    const yy = Number(y);
    if (!Number.isFinite(yy) || yy <= 0) return;

    // Wait a tick so layout is stable (folder tree can expand/collapse).
    requestAnimationFrame(() => {
      window.scrollTo({ top: yy, left: 0, behavior: "instant" });
    });
  }
}

